/**
 * Text constants used throughout the application
 * This centralizes all display text for easier localization and maintenance
 */

export const TEXT = {
  COMMON: {
    LOADING: "Loading...",
    CLOSE: "Close",
    ERROR: "An error occurred",
    NO_DATA: "No data available",
    VIEW_MORE: "Show More",
    COMING_SOON: "Coming soon",
    CURRENT_LOCATION: "Current Location",
    REGION: "Region",
    DIVISION: "Division",
  },  HEADERS: {
    LIGHTHOUSE_EXECUTION: "Lighthouse Execution",
    METRIC_SCORES: "Lighthouse Metric Scores",
    SAFETY_SPOTLIGHT: "EHS & FSQ Training Essentials",
    UPCOMING_EVENTS: "Upcoming Events",
    EXTERNAL_LINKS: "External Links",
    METRICS: "Metrics",
    CI_ACTIVE_ITEMS: "CI Active Items",
    SAFETY_TOPICS: "Weekly Safety Topics",
    CHANGE_LOG: "Change Log",
    BANNER: "Banner",
    CHANGE_LOG_TEXT:
      "Updates to the dashboard and log of current bugs needing to be fixed.",
  },
  METRICS: {
    LOADING: "Loading metrics...",
    PULSE_CHECK: "Pulse check",
    OBSERVATION: "Observation",
    SHIFT_HANDOVER: "Shift Handover",
    LEADERSHIP_WALK: "Leadership Walk",
    SPARC_WALK: "SPARC Walk",
  },
  BUTTONS: {
    SUBMIT: "Submit",
    CANCEL: "Cancel",
    SAVE: "Save",
    SEE_ALL: "See All",
    NEW_OBSERVATION: "New Observation",
  },
  TIMEFRAME: {
    LABEL: "TimeFrame",
  },
  ERRORS: {
    API_ERROR: "Failed to fetch data from the server",
    CONNECTION_ERROR: "Please check your internet connection",
  },
  HOME: {
    SAFETY_TOPICS: [
      "Safety Topic 1- *NEW*",
      "Safety Topic 2- *NEW*",
      "Safety Topic 3- *NEW*",
      "Safety Topic 4- *NEW*",
      "Safety Topic 5- *NEW*",
      "Safety Topic 6- *NEW*",
      "Safety Topic 7- *NEW*",
      "Safety Topic 8- *NEW*",
      "Safety Topic 9- *NEW*",
      "Safety Topic 10- *NEW*",
      "Safety Topic 11- *NEW*",
      "Safety Topic 12- *NEW*",
      "Safety Topic 13- *NEW*",
      "Safety Topic 14- *NEW*",
    ],
    UPCOMING_EVENTS: [
      "Scheduled trainings (both field and virtual)",
      "Community events or holidays",
      "Warehouse Safety & Compliance Training",
      "Diversity, Equity, and Inclusion Workshop",
      "New Product Launch Briefing Summer Beverages",
      "Leadership Development Bootcamp",
    ],
    EXTERNAL_LINKS: [
      "Most visited websites and reporting (ie. Copilot, Cockpit, Lighthouse Execution etc)",
      "Virtual panel discussion + local team celebrations across U.S. offices.",
      "PepsiCo-sponsored community clean-up events in select cities.",
      "Volunteer opportunities available through PepsiCo Gives Back initiative.",
    ],
    DRAWER_ITEMS: [
      { icon: "home", label: "Home", active: true },
      { icon: "dashboard", label: "Dashboard" },
      { icon: "schedule", label: "Labor Optimization" },
      { icon: "assignment", label: "Observations" },
      { icon: "sync-alt", label: "Shift Handover" },
      { icon: "people", label: "Leadership Walk" },
      { icon: "directions-walk", label: "SPARC Walk" },
      { icon: "inventory-2", label: "Racking Inspection" },
      { icon: "trending-up", label: "Continuous Improvement" },
      { icon: "email", label: "Contact Us / Feedback" },
      { icon: "search", label: "Evaluation" },
    ],
  },
  CI_DASHBOARD: {
    COLUMNS: [
      "Continuous Improvement Opportunity",
      "Solution description",
      "Target End Date",
    ],
    ON_TRACK: "On Track",
    OFF_TRACK: "Off Track",
    TOTAL: "Total",
    LOADING: "Loading CI Dashboard...",
  },
  ACCESS: {
    ALLOWED_ROLES: [
      "Developer",
      "Super User",
      "COE",
      "Region Leader/Division",
      "Site Leader",
      "Site Supervisor",
      "Checker",
      "Certifier",
      "Inventory Coordinator",
      "Team Lead",
      "Super User",
      "Area Delivery Manager",
      "Delivery District Leader",
      "Delivery Driver",
      "Delivery Senior Leadership",
      "Delivery Market Director",
      "Delivery Market Leader",
      "Delivery COE"
    ],
    DENIED_MESSAGES: {
      NO_LOCATION: "You don't have access to this application. You are not assigned to any location.",
      NO_ROLE: "You don't have access to this application. No role has been assigned to your account.",
      UNAUTHORIZED_ROLE: (roleName: string) => `You don't have access to this application. Your current role "${roleName}" is not authorized to use this application.`,
      API_ERROR: "Unable to fetch user access information. Please try again later.",
    },
  },
};
